export default "__VITE_ASSET__DH$sIQ$x__"